import React, {useCallback, useEffect, useState} from 'react';
import "./debug-popup.scss"
import AssetsUploadInput from "../input/assets-upload-input";
import {useAppSelector} from "../../redux/store";
import * as cnfStorage from '../../redux/storages/configuration-storage'
import {viewerService} from "../../services/viewer-service";

interface IProps {}

let hdrRendererUrl: any = undefined

const AssetsUploadHdrRenderer: React.FC<IProps> = () => {
    const conf = useAppSelector(cnfStorage.selectors.getConfiguration);
    const [assetUrl, setAssetUrl] = useState<any>(hdrRendererUrl)

    useEffect(() => {
            return () => {
                hdrRendererUrl = assetUrl;
            };
        }, [assetUrl]
    )

    const onUpload = useCallback(async (file: File) => {
        setAssetUrl(file.name)
        if (undefined === conf) {

            return;
        }
        const url = URL.createObjectURL(file);
        await viewerService.reinit({}, {
            imageRenderer: {
                // @ts-ignore
                scene: {
                    hdr: url
                },
            }
        })
        viewerService.showConfiguration(conf)
    },[conf])


    return (
        <AssetsUploadInput
            onUpload={onUpload}
            name={"hdr renderer"}
            fileName={assetUrl}
        />
    );
}

export default AssetsUploadHdrRenderer